import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormControl from '../../common/FormControl';
import Btn from '../../ds/atoms/btn';
import BudgetCart from './BudgetCart';

const FIELDS = {
  BUDGET_NAME: 'budget_name',
  BUDGET_EMAIL: 'budget_email',
};

class BudgetForm extends React.Component {
  constructor(props) {
    super(props);

    const {
      BUDGET_NAME,
      BUDGET_EMAIL,
    } = FIELDS;

    this.state = {
      budget_name: {
        name: BUDGET_NAME,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      budget_email: {
        name: BUDGET_EMAIL,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      loading: false,
    };

    this.label = this.label.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
  }

  handleChange(fieldName, event) {
    event.preventDefault();
    const {
      BUDGET_NAME,
      BUDGET_EMAIL,
    } = FIELDS;
    const { value } = event.target;
    const updatedState = {
      value,
    };
    if (fieldName === BUDGET_NAME) {
      this.setState({
        budget_name: {
          ...updatedState,
          name: BUDGET_NAME,
          required: true,
          valid: !!(value && value.length > 0),
        },
      });
    }
    if (fieldName === BUDGET_EMAIL) {
      this.setState({
        budget_email: {
          ...updatedState,
          name: BUDGET_EMAIL,
          required: true,
          valid: !!(value && value.length > 0),
        },
      });
    }
  }

  label(fieldName) {
    const {
      BUDGET_NAME,
      BUDGET_EMAIL,
    } = FIELDS;

    switch (fieldName) {
      case BUDGET_NAME:
        return this.context.t('Name');
      case BUDGET_EMAIL:
        return this.context.t('E-mail');
      default:
        return this.context.t('Name');
    }
  }

  onFormSubmit() {
    this.props.onSaveBudget({ name: this.state.budget_name.value, email: this.state.budget_email.value });
  }

  render() {
    const {
      lang, chain, hotel, cartHotel, lastRequestedInfo, paymentMethod,
    } = this.props;
    const cartRoom = cartHotel.rooms[0];
    const { BUDGET_NAME, BUDGET_EMAIL } = FIELDS;

    return (<div className={'BudgetForm'}>
      <div className={'content'}>
        {this.renderLoading()}
        <div className="flex">
          <div className="w-1/2 pr-2">
            <form onSubmit={this.onFormSubmit}>
              <div className={'flex'}>
                <div>
                  <h1>{this.context.t('We will send you an E-mail to guarantee your spot for 24hrs')}</h1>
                </div>
              </div>
              <div className="flex">
                <FormControl label={this.label(BUDGET_NAME)} inputData={this.state.budget_name}
                             onChange={this.handleChange}
                             className={'w-full'} required>
                  <input type="text" required/>
                </FormControl>
              </div>
              <div className="flex">
                <FormControl label={this.label(BUDGET_EMAIL)} inputData={this.state.budget_email}
                             onChange={this.handleChange}
                             className={'w-full'} required>
                  <input type="text" required/>
                </FormControl>
              </div>
              <div className={'flex py-2'}>
                <div>
                  {this.context.t('This information will not be used for promotional purposes')}
                </div>
              </div>
              <div className="flex">
                <Btn variant="primary-solid" className={'w-full'}
                     type={'submit'}>
                  <span className={'w-full uppercase text-center'}>{this.context.t('Send')}</span>
                </Btn>
              </div>
            </form>
          </div>
          <div className={'w-1/2'}>
            <BudgetCart hotel={hotel} chain={chain} lastRequestedInfo={lastRequestedInfo}
                        cartRoom={cartRoom} lang={lang} paymentMethod={paymentMethod}/>
          </div>
        </div>
      </div>
    </div>);
  }

  renderLoading() {
    if (!this.state.loading) {
      return null;
    }
    return (
            <div className={'loading'}>
              <img src={'/img/loading5.gif'}/>
              <p>{this.context.t('Wait a moment, please...')}</p>
            </div>
    );
  }
}

BudgetForm.propTypes = {
  paymentMethod: PropTypes.object,
  onSaveBudget: PropTypes.func.isRequired,
};

BudgetForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  cart: state.cart,
  cartHotel: state.cart.cartHotel,
  hotel: state.booking.hotel,
  chain: state.bookingFormState.chain,
  lastRequestedInfo: state.booking.last_requested_info,
  lang: state.i18nState.lang,
}))(BudgetForm);
